export default __webpack_public_path__ + "static/media/ownershipIcon.be01bf7a.svg";